import { useState } from 'react'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import MoneyInput from 'components/Inputs/MoneyInput'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import earningAndExpenseValidator from 'validators/earningAndExpenseValidator'
import { Formik } from 'formik'

import {
  Form,
  FormField,
  Input,
  Row,
  InfoText,
  WarningText,
  ErrorContainer
} from './styles'

export default function AddCustomerDebtModal ({
  visible,
  customer,
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Adicionar dívida</DialogTitle>
        </DialogHeader>
        <Formik
          validationSchema={earningAndExpenseValidator}
          initialValues={{
            'value': 0,
            'description': '',
            'customerId': customer.id
          }}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              const { data: debt } = await cutileiApi.post (
                `/businesses/${businessId}/debts`, values, requestConfig
              )

              setSubmitting (false)
              handleConfirm (debt)
              handleClose ()
            } catch (error) {
              setErrorMessage (getApiErrorMessage (error))
              setSubmitting (false)
              logApiError (error)
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => {
            return (
              <>
                <DialogBody>
                  <Form onKeyDown={submitOnEnter(handleSubmit, isSubmitting)}>
                    <Row>
                      <FormField>
                        <MoneyInput
                          name='value'
                          placeholder='Valor'
                          value={values.value}
                          onValueChange={setFieldValue}
                          onBlur={handleBlur ('value')}
                        />
                        {touched.value && errors.value && (
                          <WarningText>
                            {errors.value}
                          </WarningText>
                        )}
                      </FormField>
                      <FormField>
                        <Input 
                          placeholder='Descrição'
                          value={values.description}
                          onChange={handleChange ('description')} 
                          onBlur={handleBlur ('description')}
                        />
                        {touched.description && errors.description && (
                          <WarningText>
                            {errors.description}
                          </WarningText>
                        )}
                      </FormField>
                    </Row>
                    {errorMessage && (
                      <ErrorContainer>
                        <InfoText>{errorMessage}</InfoText>
                      </ErrorContainer>
                    )}
                  </Form>
                </DialogBody>
                <DialogFooter>
                  <MainButton
                    label='Adicionar dívida'
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    width={180}
                  />
                </DialogFooter>
              </>
            )
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
